// mixins.ts
import { Vue, Component } from "vue-property-decorator";
import user_avater from "../assets/images/default/img_doc_emp@2x.png";
import doc_default from "@/assets/images/default/img_doc_emp@2x.png";
import hos_default from "@/assets/images/default/img_hos_emp@2x.png";
import banner_default from "@/assets/images/default/banner.jpg";
import store from "../store";
// import service from "@/service";
import authCodeMap from "@/dataBase/authCodeMap";
import { service as communityService } from "@modules/community/setup";
// import { deepFind } from "@/utils/commonUtil";
// declare module 'vue/types/vue' {
//   interface Vue {
//     methodFromMixins(value: number | string): void;  // 记得声明一下，要不然会报错 Property 'methodFromMixins' does not exist on type 'App'.
//   }
// }
// const APP_URL = "https://business.wenwo.com/medicine";
const PIC_URL = `${process.env.VUE_APP_B_HEALTH_LINK}`;
const SUB_FIX = `${process.env.VUE_APP_B_HEALTH_LINK}`;
import { logoutRemoveNew } from "@/utils/userStorage";

Component.registerHooks(["beforeRouteEnter"]);
@Component({
  filters: {
    limit: function (val: string, param: number) {
      let result = val || "-";
      if (result && result.length > param) {
        result = result.substring(0, param) + "...";
      }
      return result;
    },
    dateFormat: (val: string) => {
      if (!val) return "";
      if (typeof val == "string") {
        val = val.replace(/-/g, "/").replace(/T/g, " "); // 浏览器不识别 -
      }
      function fix(num: number) {
        return num >= 10 ? num : "0" + num;
      }
      const date = new Date(val),
        year = date.getFullYear(),
        month = fix(date.getMonth() + 1),
        day = fix(date.getDate()),
        hour = fix(date.getHours()),
        minute = fix(date.getMinutes()),
        seconds = fix(date.getSeconds());

      return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + seconds;
    },
  },
})
export default class commonNewMixins extends Vue {
  codes: any = authCodeMap;
  initing_page = false;
  $logger: any;
  get isNew() {
    return this.$route.meta?.isNew;
  }
  get VX_comtyId() {
    return store.state.comtyIdNew;
  }
  get VX_comtyInfo() {
    return store.state.comtyInfoNew;
  }
  get VX_permissionList() {
    return store.state.permissionListNew;
  }
  get VX_pagePermissionList() {
    return store.state.pagePermissionListNew;
  }
  get VX_userInfo() {
    return store.state.userInfoNew;
  }
  // 指定社区隐藏 审订 关键字内容
  get VX_hideRevise() {
    return this.VX_comtyId === "6785c53d098d7f4ab6e935ee";
  }
  /////////////
  async checkShopAuditStatus(callback: Function) {
    const res = await communityService.shopDetailInfo({ id: this.VX_comtyInfo.communityId });
    console.log("shopDetailInfo", res);
    if (res.code == 200) {
      if (res.data.auditStatus == 0) {
        this.$confirm("您还未提交零售商信息，请先完善零售商信息再来使用此功能吧~", "提示", {
          confirmButtonText: "去修改",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push({
            name: authCodeMap.community_deco_index_comty_info,
          });
        });
        return;
      }
      if (res.data.auditStatus == 1) {
        this.$confirm("您提交的零售商信息正在审核中，请审核通过后再来使用此功能吧~", "提示", {
          confirmButtonText: "好的",
          cancelButtonText: "取消",
          showCancelButton: false,
          type: "warning",
        });
        return;
      }
      if (res.data.auditStatus == 3) {
        this.$confirm("您提交的零售商信息审核不通过，请重新修改提交审核通过后再来使用此功能吧~", "提示", {
          confirmButtonText: "修改",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push({
            name: authCodeMap.community_deco_index_comty_info,
          });
        });
        return;
      }
      callback();
    } else {
      this.$message.warning("网络异常请稍后再试");
    }
  }
  checkAuditStatus(callback: Function) {
    // console.warn(this.VX_comtyInfo.auditStatus);
    if (this.VX_comtyInfo.auditStatus == "PASS") {
      callback();
      return;
    }
    if (this.VX_comtyInfo.auditStatus == "NOT_PASS") {
      this.$confirm("很抱歉您提交的社区信息审核不通过，请重新修改并提交审核后再来使用此功能把~", "提示", {
        confirmButtonText: "去修改",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$router.push({
          name: authCodeMap.community_info,
        });
      });
      return;
    }
    if (this.VX_comtyInfo.auditStatus == "UNVERIFIED") {
      this.$confirm("您还未提交社区认证，请先完成社区认证再来使用此功能把~", "提示", {
        confirmButtonText: "去认证",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$router.push({
          name: authCodeMap.community_info,
        });
      });
      return;
    }
    if (this.VX_comtyInfo.auditStatus == "PENDING") {
      this.$confirm("您提交的社区信息正在审核中，请耐心等候~", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      return;
    }
    if (this.VX_comtyInfo.expireSource == "ANNUAL") {
      this.$confirm("您社区的资质认证未通过年审，请重新认证通过后再来使用此功能吧~", "提示", {
        confirmButtonText: "重新认证",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$router.push({
          name: authCodeMap.community_audit,
        });
      });
      return;
    }
    if (this.VX_comtyInfo.expireSource == "QUALIFICATION") {
      this.$confirm("您的社区信息认证已过期，请重新认证通过后再来使用此功能吧~", "提示", {
        confirmButtonText: "重新认证",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$router.push({
          name: authCodeMap.community_audit,
        });
      });
      return;
    }
  }
  getPermission(id: string) {
    // console.warn("permissionKey", id);
    const permissionDebug = location.href.includes("debug");
    if (permissionDebug) {
      console.log("[commonNewMixins][getPermission] 放开权限", process.env.NODE_ENV);
      return true;
    } else {
      //console.count("当前已做权限校验，可在链接带上debug不作权限码校验");
    }
    const verify_code = new URLSearchParams(location.search).get("verify_code");
    if (verify_code) {
      if (!this.codes[id]) {
        console.log("没权限 verify_code", id, this.codes);
      } else {
        console.log("有权限 verify_code", id);
      }
    }

    // console.log("process.env.NODE_ENV", process.env.NODE_ENV);
    const permissionKey = this.codes[id];
    if (permissionKey && this.VX_pagePermissionList) {
      const permission: any = this.VX_pagePermissionList;
      if (permission.length > 0) {
        const find = permission.find((item: any) => {
          return item == permissionKey;
        });
        return find;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
  getFormatParams(params: any) {
    const newParams: any = {};
    for (const key in params) {
      if (params[key] || params[key] === 0 || params[key] === false) {
        newParams[key] = params[key];
      }
    }
    return newParams;
  }
  tableEmptyFormatter(row: any, column: any, cellValue: any) {
    return cellValue || "--";
  }
  markPhoneFormatter(row: any, column: any, cellValue: any) {
    return cellValue || "--";
  }
  GET_IMG_URL(picID: any, type: String | Number) {
    let url = picID;
    if (picID == "" || picID == null || picID == undefined) {
      if (type == "u") {
        url = user_avater;
      } else if (type == "b") {
        url = banner_default;
      } else if (type == "doc") {
        url = doc_default;
      } else if (type == "hos") {
        url = hos_default;
      }
    } else {
      if (/http/.test(picID)) {
        //网络图片
      } else {
        //图片服务器图片
        url = PIC_URL + picID + SUB_FIX;
      }
    }
    return url;
  }

  router_back() {
    this.$router.back();
  }
  showTip(msg: any) {
    if (msg && msg != "") {
      this.$message({
        type: "error",
        message: msg,
      });
    }
  }
  accountLogOut(accountLogOut = "") {
    logoutRemoveNew();
    location.href = "/newCommunity/login" + accountLogOut;
  }
  // 获取当天时间
  getNewDate() {
    function fix(num: number) {
      return num >= 10 ? num : "0" + num;
    }
    const date = new Date(),
      year = date.getFullYear(),
      month = fix(date.getMonth() + 1),
      day = fix(date.getDate());
    return year + "-" + month + "-" + day;
  }
}
